import { graphql } from "../generated";

// Dev-only: lists the most recent call conversations so the local dev server
// has a browsable landing page at "/" to open calls from. `token: "1"` fetches
// the first page (mirrors conversation-center-ext's known-good caller).
//
// The selection mirrors conversation-center-ext's callConversationFragment so
// its ported table renderers (mapToRowData, getUser, getNumber, getCustomer,
// getVirtualAgents, getTranscript) work unchanged. It also includes every field
// the assets-page Apollo cache uses as a keyField (see cache.config.ts), else
// those objects fail to normalize and the whole list reads back empty:
// Line -> `ID`, ConversationAgent -> `agentDetails.agentId`,
// ConversationContact -> `phoneNumber`, CallConversation -> `callId`.
export const DevCallConversations = graphql(
  `
    query DevCallConversations($token: String!, $limit: Int) {
      getCallConversations(token: $token, limit: $limit) {
        items {
          callId
          type
          startTime
          durationInSeconds
          predictedCsatScore
          line {
            ID
            name
            countryISOCode
            phoneNumber
            language
          }
          agents {
            agentDetails {
              agentId
            }
            teammate {
              entity {
                __typename
                ... on PhoneTeammate {
                  ID
                  fullName
                }
              }
            }
          }
          virtualAgents {
            virtualAgent {
              entity {
                __typename
                ... on VirtualAgent {
                  ID
                  personality {
                    name
                  }
                }
              }
            }
          }
          contacts {
            phoneNumber
            external {
              entity {
                __typename
                ... on PhoneContact {
                  fullName
                  mainPhoneNumber
                  companyName
                }
                ... on ExternalNumber {
                  phoneNumber
                }
              }
            }
          }
          sentiment {
            overall {
              customer
            }
          }
          transcription {
            ... on CallTranscription {
              status
            }
            ... on VoicemailTranscription {
              status
            }
          }
          transcriptionScope {
            totalItems
          }
        }
        pageInfo {
          total
          nextToken
        }
      }
    }
  `
);
